import { OverlayTrigger } from 'react-bootstrap'
import { convertDecimalMinutesToMMSS } from '../../../../../../utils/commonFunctions'
import { GroundStationPass } from '../../../../../CommonComponents/orbital-insights/orbital-insights-type'
import { getUtcFormattedDate } from '../../../utils/helperFunction'
import './OrbitalInsightsOverlay.scss'

const ContactsOverlay = ({ Events }: { Events: GroundStationPass[] }) => {
    return (
        <div className="orbital__insights__overLay__container">
            {Events.map((event, index) => {
                return (
                    <div className="orbital__insights__overLay__card" key={`contact-${index}`}>
                        <OverlayTrigger
                            key={`contact-${index}`}
                            placement="auto"
                            overlay={
                                <div className='orbital__insights__overLay__card__body'>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{event?.['startTime'] && getUtcFormattedDate(event?.['startTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>Start Time</span>
                                        </div>
                                        <div className='card_info align__end'>
                                            <span className='fs-13'>{event?.['endTime'] && getUtcFormattedDate(event?.['endTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>End Time</span>
                                        </div>
                                    </div>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{(event?.duration) && `${convertDecimalMinutesToMMSS(event?.duration / 60)}`}</span>
                                            <span className='fs-12 opacity-50'>Total Duration</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        >
                            <div className='orbital__insights__overLay__card__header'>
                                <div className='d-flex flex-column align-items-start w-50'>
                                    <span className='w-98 text-truncate fs-13' title={event?.['groundStationName']}>{event?.['groundStationName']}</span>
                                    <span className='fs-12 opacity-50'>Ground Station</span>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div>
                )
            })}
        </div >
    )
}

export default ContactsOverlay